<template>
	<div id="app">
		<router-view v-if="$route.meta.public" />
		<el-container v-else class="app-layout">
			<!-- 如果是公开页面（如登录），直接渲染 router-view，没有任何布局 -->
			<!-- 1. 顶部 Header (固定 60px) -->
			<el-header class="app-header" height="60px">
				<div class="logo">佳喜祥后台管理系统</div>
				<div class="user-info" @click="logout">{{ userInfo?.userName || "未登录" }}</div>
			</el-header>

			<el-container class="main-wrapper">
				<!-- 2. 左侧侧边栏 -->
				<el-aside width="220px" class="app-aside">
					<slid-bar></slid-bar>
				</el-aside>

				<!-- 3. 主内容区域 (滚动核心) -->
				<el-main class="app-main">
					<!-- 大卡片 -->
					<div class="app-card">
						<router-view />
					</div>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<script>
	import SlidBar from "./components/SlidBar.vue";
	export default {
		components: { SlidBar },
		computed: {},
		data() {
			return {
				userInfo: {},
			};
		},
		created() {
			const userInfo = sessionStorage.getItem("userInfo");
			this.userInfo = JSON.parse(userInfo);
			console.log("用户信息", JSON.stringify(this.userInfo));
			setInterval(() => {
				const userInfo = sessionStorage.getItem("userInfo");
				this.userInfo = JSON.parse(userInfo);
			}, 1000);
			// if (!this.userInfo) {
			// 	this.$message.warning("用户未登录");
			// 	setTimeout(() => {
			// 		this.$router.push("/login");
			// 	}, 1000);
			// }
		},
		methods: {
			logout() {
				this.$confirm("确认退出登录吗？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
					.then(() => {
						// 调用 Vuex 的 logout action
						this.$store
							.dispatch("logout")
							.then(() => {
								// 跳转到登录页（可携带 redirect 参数，但退出通常直接去登录页）
								this.$router.push("/login");
							})
							.catch((err) => {
								console.error("退出失败", err);
								this.$message.error("退出失败");
							});
					})
					.catch(() => {
						// 用户取消，不做处理
					});
			},
		},
	};
</script>

<style lang="scss">
	/* 全局重置：确保最外层不滚动 */
	html,
	body {
		margin: 0;
		padding: 0;
		height: 100%;
		overflow: hidden; /* 禁止 body 滚动 */
	}

	#app {
		height: 100%;
		width: 100%;
	}

	/* 整体布局 */
	.app-layout {
		height: 100%;
		width: 100%;
	}

	/* 顶部 Header */
	.app-header {
		background-color: #fff;
		border-bottom: 1px solid #e6e6e6;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 20px;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
		z-index: 10;
		/* Element UI el-header 默认 height 是 60px，这里显式声明一下更稳妥 */
		height: 60px;
	}

	/* 中间包裹层 (Aside + Main) */
	.main-wrapper {
		/* 关键：高度 = 100% 总高 - Header 高度 */
		height: calc(100% - 60px);
		overflow: hidden; /* 防止 wrapper 本身滚动 */
	}

	/* 左侧侧边栏 */
	.app-aside {
		//   background-color: #304156;
		overflow-y: auto;
		transition: width 0.3s;
	}

	/* 右侧主内容区 (滚动容器) */
	.app-main {
		background-color: #f0f2f5;
		padding: 20px;
		/* 关键：高度 100% 填满父容器，超出部分内部滚动 */
		height: 100%;
		overflow-y: auto;
		overflow-x: hidden;
		position: relative;

		/* 优化滚动条体验 */
		&::-webkit-scrollbar {
			width: 8px;
		}
		&::-webkit-scrollbar-thumb {
			background: #c1c1c1;
			border-radius: 4px;
			&:hover {
				background: #a8a8a8;
			}
		}
	}

	/* 大卡片风格 */
	.app-card {
		background: #fff;
		border-radius: 4px;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
		padding: 20px;
		width: 100%;

		/* 关键：最小高度设为 100%，让它在内容少时也能“拉开”填满可视区域 */
		/* 注意：这里的 100% 是相对于 .app-main 的内容区，配合 min-height 使用 */
		min-height: calc(100% - 0px);

		/* 如果想让它严格等于屏幕剩余高度（即使内容很少也撑满），可以用下面这个计算值 */
		/* 但通常 min-height: 100% 在 flex 布局下已经足够 */
		min-height: 100%;

		/* 确保盒模型正确 */
		box-sizing: border-box;
	}
</style>
